var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer__social-icons"},_vm._l((_vm.soMeEntries),function(entry){return _c('span',{key:entry.type},[(entry.link)?_c('a',{attrs:{"href":entry.link,"target":"_blank"}},[_c('FontAwesomeIcon',{attrs:{"icon":entry.icon,"size":"1x"}}),_c('span',{staticClass:"footer__social-text"},[_vm._v(_vm._s(entry.type))])],1):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }